/**
 * Centralized pagination configuration.
 *
 * Replaces the scattered hardcoded limits (1000 / 2000 / 5000) that screens used
 * to fetch "all" schedules in one request and then filter client-side. Use these
 * constants instead of inlining magic numbers.
 *
 * Guidance:
 * - For a paginated list UI, request `DEFAULT_PAGE_SIZE` per page and pass `page`.
 * - To retrieve an entire dataset for export or a full-set computation, use the
 *   `listAll` helpers (which page through the backend in `*_LISTALL_PAGE_SIZE`
 *   chunks) rather than a single large `limit`.
 */

/** Rows shown per page in list UIs (matches the backend default intent). */
export const DEFAULT_PAGE_SIZE = 10;

/** Chunk size used by paginate-all helpers when looping the schedules endpoint. */
export const SCHEDULES_LISTALL_PAGE_SIZE = 500;

/** Chunk size used by paginate-all helpers when looping the participants endpoint. */
export const PARTICIPANTS_LISTALL_PAGE_SIZE = 500;

/**
 * Hard cap the backend enforces on GET /schedules `limit` (see schedules.js
 * MAX_SCHEDULE_LIMIT). Requests above this are clamped server-side. It equals
 * SCHEDULES_LISTALL_PAGE_SIZE so paginate-all chunks pass unclamped while the
 * old limit:1000/2000/5000 single fetches are bounded. Keep the two in sync.
 */
export const MAX_SCHEDULE_PAGE_LIMIT = 500;
